import { useEffect, useState } from 'react'

import { useDebounce } from '@/shared/hooks/useDebounceHook'
import { SearchResultType } from '@/types/search/searchResultType'
import getSearchResults from '../lib/searchService'
import { debounceSpeedMedium } from '@/shared/constants/appConstants'

export const useSearchResult = (query: string) => {
    const [resultsArray, setResultsArray] = useState<Array<SearchResultType>>(
        []
    )

    const debouncedValue = useDebounce(query, debounceSpeedMedium)
    const getResults = async () => {
        const response = await getSearchResults(query)

        if (response) {
            const responseArray = response.searchResults

            setResultsArray(responseArray)
        }
    }

    useEffect(() => {
        setResultsArray([])
        getResults()
    }, [debouncedValue])

    return resultsArray
}
